import { Box, Divider, makeStyles, Typography } from '@material-ui/core'

import { format, parseISO } from 'date-fns'
import React from 'react'

import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12
  },
  name: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    color: PRIMARY_COLORS[700]
  },
  date: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    color: GRAY_COLORS[400]
  },
  text: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    color: GRAY_COLORS[700]
  }
}))

const CommentItem = ({ comment, isLast = false }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      {!!comment?.text && (
        <>
          <Box className={classes.row}>
            <Typography className={classes.name}>
              {comment?.userFullName}
            </Typography>

            {comment?.createdDate && (
              <Typography className={classes.date}>
                {format(parseISO(comment.createdDate), 'HH:mm dd.MM.yyyy')}
              </Typography>
            )}
          </Box>

          <Box
            className={classes.row}
            style={{
              marginTop: 5
            }}
          >
            <Typography className={classes.text}>{comment?.text}</Typography>
          </Box>
        </>
      )}

      {!isLast && (
        <Divider
          style={{
            marginTop: 12,
            marginBottom: 12
          }}
        />
      )}
    </Box>
  )
}

export default CommentItem
